import Vue from 'vue';

// Tamaño de la ventana como estado reactivo compartido: un solo listener de resize para toda la
// aplicación, y cualquier componente que lea `Ventana.ancho` en su render se actualiza solo.
// Lo usan los listados para decidir si agrupan las acciones de línea (≤1024px, el mismo corte que
// el CSS responsive de rDynamicList).
// `window` con guarda de typeof y NO `globalThis`: el proyecto apunta a WebViews y Safari antiguos
// (browserslist: Android >= 7, iOS >= 11) que no lo tienen, y Babel no mete su polyfill; este
// módulo se carga al arrancar, así que un fallo aquí dejaría la app sin iniciar.
const ventana = typeof window === 'undefined' ? null : window;

const Ventana = Vue.observable({
  ancho: ventana ? ventana.innerWidth : 0,
  alto: ventana ? ventana.innerHeight : 0
});

if (ventana) {
  ventana.addEventListener('resize', () => {
    Ventana.ancho = ventana.innerWidth;
    Ventana.alto = ventana.innerHeight;
  });
}

export default Ventana;
